import React from 'react';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const ObrigacoesIMPA = ({ edicao }) => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-09" className={classes.title}>
                9. OBRIGAÇÕES DO IMPA
            </Title>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>9.1</span>
                O <span className={classes.bolder}> IMPA</span>, como responsável único pela realização da Olimpíada de Professores da OBMEP Mirim, terá as seguintes atribuições:
                
                <ul className={classes.list}>
                    <li><span className={classes.item}>{"a)"}</span> Planejamento e organização do projeto;</li>
                    <li><span className={classes.item}>{"b)"}</span> Elaboração das provas e dos gabaritos;</li>
                    <li><span className={classes.item}>{"c)"}</span> Processamento das informações enviadas pelos professores;</li>
                    <li><span className={classes.item}>{"d)"}</span> Aplicação da prova;</li>
                    <li><span className={classes.item}>{"e)"}</span> Correção das provas e indicação de todas as premiações;</li>
                    <li>
                        <span className={classes.item}>{"f)"}</span> Conservação das provas em meio físico pelo período de 4 (quatro) meses e em meio digital 
                        (cópia digitalizada) pelo período de 5 (cinco) anos, a contar da data da divulgação dos resultados. Após esse período, o <span className={classes.bolder}>IMPA</span> poderá realizar o descarte do material para reciclagem;;
                    </li>
                    <li><span className={classes.item}>{"g)"}</span> Manutenção da página atualizada com informações sobre a {edicao}ª Olimpíada de Professores da OBMEP Mirim.</li>
                </ul>
            </Typography>
        </>
    )
}

export default ObrigacoesIMPA;